import { render, staticRenderFns } from "./screening-task-content.vue?vue&type=template&id=b4634420&scoped=true"
import script from "./screening-task-content.vue?vue&type=script&lang=js"
export * from "./screening-task-content.vue?vue&type=script&lang=js"
import style0 from "./screening-task-content.vue?vue&type=style&index=0&id=b4634420&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4634420",
  null
  
)

export default component.exports